import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { SectionChanges } from '@app/shared/components/scope-elements/models/entities-with-changes/section-with-changes.interface'

export function getSectionChanges(
  section: ScopeSection,
  previewSection: ScopeSection,
  isChangeRequest: boolean,
  newDeliverables: Deliverable[]
): SectionChanges {
  if (!previewSection) previewSection = section

  return {
    markup: {
      old: +section?.getTotalMarkup(),
      new: +previewSection?.getTotalMarkup(false, newDeliverables),
    },
    totalProfit: {
      old: section?.getTotalProfit()?.amount,
      new: previewSection?.getTotalProfit(false, newDeliverables)?.amount,
    },
    rateCardTotalHours: {
      old: section?.getAgencyHours(),
      new: previewSection?.getAgencyHours(!isChangeRequest, newDeliverables),
    },
    totalSellingPrice: {
      old: section?.getTotalSellingPrice([], true)?.amount,
      new: previewSection?.getTotalSellingPrice(newDeliverables, !isChangeRequest)?.amount,
    },
  }
}
